<template>
	<div id="empresa-editar">
		<ld-popup
			id="popup-editar-empresa"
			:fullscreen="true"
			:active.sync="popupEditarEmpresa"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
			:closed="funcaoFechar"
		>
			<div class="flex justify-between w-full p-2 pb-5" slot="header">
				<div class="flex items-center w-1/2">
					<div class="content-title mr-32">
						<h2 class="title">Editar empresa</h2>
					</div>
				</div>

				<div class="flex justify-end">
					<ld-button
						color="danger"
						icon-pack="feather"
						icon="icon-lock"
						class="mr-8"
						@click="popupBloquearEmpresa = true"
					>
						Bloquear empresa
					</ld-button>
					<ld-button
						icon-pack="feather"
						icon="icon-x"
						size="large"
						color="dark"
						type="flat"
						@click="popupCancelarEdicao = true"
					></ld-button>
				</div>
			</div>

			<vx-card>
				<form
					v-if="empresa"
					id="form-empresa-editar"
					class="relative px-4 py-5"
					@submit.prevent="editarEmpresa"
				>
					<div class="flex flex-col w-full">
						<div class="dados-empresa">
							<h4 class="subtitle my-10 font-bold">Dados da empresa</h4>

							<vs-input
								class="w-full mb-4"
								label="Nome"
								name="nome"
								v-model="empresa.nome"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Nome fantasia"
								name="fantasia"
								v-model="empresa.nomeFantasia"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="CNPJ"
								name="cnpj"
								v-mask="'##.###.###/####-##'"
								v-model="empresa.cnpj"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="E-mail"
								name="email"
								v-model="empresa.email"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Telefone"
								name="telefone"
								v-mask="['(##) # ####-####', '(##) ####-####']"
								v-model="empresa.telefone"
							></vs-input>
						</div>

						<div class="divider-vertical"></div>

						<div class="endereco">
							<h4 class="subtitle my-10 font-bold">Endereço</h4>

							<vs-input
								class="w-full mb-4"
								label="CEP"
								name="cep"
								v-mask="'#####-###'"
								v-model="empresa.cep"
								@input="consultarCEP"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Rua"
								name="logradouro"
								v-model="empresa.logradouro"
							></vs-input>

							<vs-input
								class="md:w-2/5 w-full mb-4"
								label="Número"
								name="numero"
								type="number"
								v-model="empresa.numero"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Complemento (Opcional)"
								name="complemento"
								v-model="empresa.complemento"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Bairro"
								name="bairro"
								v-model="empresa.bairro"
							></vs-input>

							<vs-input
								class="w-full mb-4"
								label="Cidade"
								name="cidade"
								v-model="empresa.cidade"
							></vs-input>

							<ld-select
								parent="#form-empresa-editar"
								label="Estado"
								name="estado"
								:model.sync="empresa.estado"
								:list.sync="listEstados"
							/>
						</div>
					</div>

					<div class="flex flex-wrap items-center justify-end mt-10">
						<ld-button
							class="mr-4 mt-2"
							type="border"
							@click="popupCancelarEdicao = true"
							>Cancelar</ld-button
						>
						<ld-button class="mt-2" buttonType="submit"
							>Salvar alterações</ld-button
						>
					</div>
				</form>
			</vx-card>


			<ld-popup
				title="Cancelar edição?"
				:active.sync="popupCancelarEdicao"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja cancelar a edição da empresa? Se
					cancelar, todos os dados inseridos serão perdidos.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="cancelarEdicao"
							>Cancelar edição</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupCancelarEdicao = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Bloqueio de empresa?"
				:active.sync="popupBloquearEmpresa"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja bloquear a empresa?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupBloquearEmpresa = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="bloquearEmpresa"
							>Bloquear</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				:title="
					`Empresa ${
						copiaEmpresa && copiaEmpresa.bloqueada
							? 'bloqueada'
							: 'alterada'
					}`
				"
				:active.sync="popupEmpresaEditada"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>
					A empresa "{{ empresa ? empresa.nome : "" }}" foi
					{{
						copiaEmpresa && copiaEmpresa.bloqueada
							? "bloqueada"
							: "alterada"
					}}.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-32"
							color="primary"
							type="filled"
							@click="cadastroFinalizado"
							>OK</vs-button
						>
					</div>
				</div>
			</ld-popup>
		</ld-popup>
	</div>
</template>

<script>
import Empresa from "../../../models/Empresa";
import ErrorHelper from "../../../helpers/ErrorHelper";
import Estado from "../../../models/Estado";
import CEPHelper from "../../../helpers/CEPHelper";

export default {
	name: "EmpresaEditar",
	data() {
		return {
			popupCancelarEdicao: false,
			popupEmpresaEditada: false,
			popupBloquearEmpresa: false,
			copiaEmpresa: null
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
		empresa: {
			required: true
		}
	},
	computed: {
		popupEditarEmpresa: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		},
		listEstados() {
			const estados = Estado.getMap();

			const listEstados = [
				{},
				...Object.keys(estados).map(estado => {
					return {
						text: estado,
						value: estados[estado]
					};
				})
			];

			return listEstados;
		}
	},
	methods: {
		async editarEmpresa() {
			const loadingEditarEmpresa = this.$vsloading({
				container: "#popup-editar-empresa",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Empresa.editar(this.empresa);
				this.popupEmpresaEditada = true;
			} catch (error) {
				ErrorHelper.renderFormError("#form-empresa-editar", error);
			} finally {
				loadingEditarEmpresa.hide();
			}
		},
		async bloquearEmpresa() {
			this.popupBloquearEmpresa = false;

			const loadingEditarEmpresa = this.$vsloading({
				container: "#popup-editar-empresa",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				this.copiaEmpresa.bloqueada = true;

				await Empresa.editar(this.copiaEmpresa);
				this.popupEmpresaEditada = true;
			} catch (error) {
				ErrorHelper.renderFormError("#form-empresa-editar", error);
			} finally {
				loadingEditarEmpresa.hide();
			}
		},
		cancelarEdicao() {
			this.popupCancelarEdicao = false;
			this.popupEditarEmpresa = false;
		},
		cadastroFinalizado() {
			this.popupEmpresaEditada = false;
			this.popupEditarEmpresa = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			const form = document.querySelector("#form-empresa-editar");
			ErrorHelper.cleanFormErrors(form);
		},
		async consultarCEP(cep) {
			try {
				await CEPHelper.consultarCEP.get(cep, this.empresa);
			} catch (error) {
				console.error(error);
			}
		}
	},
	watch: {
		active() {
			if (this.active) {
				this.copiaEmpresa = new Empresa(
					JSON.parse(JSON.stringify(this.empresa))
				);
			}
		}
	}
};
</script>

<style lang="scss" src="./empresa_editar.scss"></style>
